import { get } from './http'

/** 兼容后端返回：数组、`{ data: [...] }`、`{ list: [...] }` */
function unpackList(data) {
  if (Array.isArray(data)) return data
  if (data && typeof data === 'object') {
    if (Array.isArray(data.data)) return data.data
    if (Array.isArray(data.list)) return data.list
    if (Array.isArray(data.items)) return data.items
  }
  return []
}

/** 首页课程推荐 */
export function fetchCourses() {
  return get('/course', { sort_type: 1 }).then(unpackList)
}

/** 首页名师推荐 */
export function fetchTeachers() {
  return get('/teacher', { is_recommended: 1, sort_type: 1 }).then(unpackList)
}

/** 首页考学资讯 */
export function fetchNews() {
  return get('/news', { is_recommended: 1, sort_type: 1 }).then(unpackList)
}

/** 首页轮播（/app/meta 的 banner 数组） */
export async function fetchBanners() {
  const meta = await get('/app/meta')
  const banners = meta?.banner
  return Array.isArray(banners) ? banners : []
}
